import { render, staticRenderFns } from "./SkeletonDetail.vue?vue&type=template&id=625090f4"
import script from "./SkeletonDetail.vue?vue&type=script&lang=js"
export * from "./SkeletonDetail.vue?vue&type=script&lang=js"
import style0 from "./SkeletonDetail.vue?vue&type=style&index=0&id=625090f4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625090f4')) {
      api.createRecord('625090f4', component.options)
    } else {
      api.reload('625090f4', component.options)
    }
    module.hot.accept("./SkeletonDetail.vue?vue&type=template&id=625090f4", function () {
      api.rerender('625090f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commons/skeletonLoader/SkeletonDetail.vue"
export default component.exports